import Vue from 'vue';

import axios from 'axios';
import VueAxios from 'vue-axios';
import {parseLaravelError, showSnackbar} from "../functions";
import i18n from "./i18n";

axios.defaults.baseURL = process.env.APP_URL;

axios.interceptors.response.use(
    response => {
        if (response.status === 201)
            showSnackbar('success', i18n.t('success.created'))
        if (response.config.method.toLowerCase() === "patch" || response.config.method.toLowerCase() === "put")
            showSnackbar('success', i18n.t('success.updated'))
        if (response.config.method.toLowerCase() === "delete")
            showSnackbar('success', i18n.t('success.deleted'))
        return response
    },
    err => {
        switch (err.response.status) {
            case 401:
                break
            case 403:
                showSnackbar('warning', i18n.t('errors.forbidden'))
                break
            case 404:
                showSnackbar('warning', i18n.t('errors.not_found'))
                break
            case 422:
                showSnackbar('warning', ...parseLaravelError(err.response));
                break
            case 500:
                showSnackbar('error', i18n.t('errors.server_error'))
                break
            default:
                showSnackbar('error', i18n.t('errors.unknown', [err.response.status]))
        }

        return Promise.reject(err)
    }
)

Vue.use(VueAxios, axios);

export default (app) => {
    app.axios = axios;
    app.$http = axios;

    app.config.globalProperties.axios = axios;
    app.config.globalProperties.$http = axios;
}
